<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="selectedLanguage" page="gb" :gotodownload="gotodownload" :apk="apk"/>

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          
          <!-- Hero Section -->
          <section class="hero-section">
            <div class="hero-floating-shapes">
              <div class="shape shape-1"></div>
              <div class="shape shape-2"></div>
              <div class="shape shape-3"></div>
            </div>
            <div class="hero-content">
              <h1><span v-html="t.heroTitlePart1"></span> <span class="highlight">{{ t.heroTitleHighlight }}</span><br>{{ t.heroTitlePart2 }}</h1>
              <p class="hero-description"><span v-html="t.heroDesc"></span></p>
              <div class="hero-buttons">
                <button class="download-btn" @click="downloadClick">
                  <img src="@/assets/android.webp" alt="android"> {{ t.heroBtn }}
                </button>
              </div>
              <p class="version-info">{{ t.versionInfo }}</p>
            </div>
          </section>

          <!-- Table of Contents -->
          <details class="toc-section" v-if="showTableOfContents">
            <summary>{{ t.tocTitle }}</summary>
            <ul>
              <li><a href="#key-features">{{ t.tocFeatures }}</a></li>
              <li><a href="#download">{{ t.tocDownload }}</a></li>
              <li><a href="#installation">{{ t.tocInstall }}</a></li>
              <li><a href="#safety">{{ t.tocSafety }}</a></li>
              <li><a href="#update">{{ t.tocUpdate }}</a></li>
              <li><a href="#transfer">{{ t.tocTransfer }}</a></li>
              <li><a href="#account-safety">{{ t.tocAccountSafety }}</a></li>
              <li><a href="#why-choose">{{ t.tocWhyChoose }}</a></li>
              <li><a href="#backup">{{ t.tocBackup }}</a></li>
              <li><a href="#web-pc">{{ t.tocWebPc }}</a></li>
              <li><a href="#troubleshooting">{{ t.tocTrouble }}</a></li>
              <li><a href="#alternatives">{{ t.tocAlternatives }}</a></li>
              <li><a href="#gbwhatsapp-vs-other-mods">{{ t.tocVsMods }}</a></li>
              <li><a href="#privacy-features">{{ t.tocPrivacy }}</a></li>
              <li><a href="#customization">{{ t.tocCustom }}</a></li>
              <li><a href="#faq">{{ t.tocFaq }}</a></li>
            </ul>
          </details>

          <!-- Key Features -->
          <section id="key-features" class="content-section">
            <h2><span v-html="t.keyFeaturesTitle"></span></h2>
            <p>{{ t.keyFeaturesIntro }}</p>
            <ul class="feature-list">
              <li v-for="(feat, fx) in t.keyFeatureItems" :key="'kf'+fx"><strong>{{ feat.title }}</strong> {{ feat.body }}</li>
            </ul>
            <div class="feature-screenshots" v-if="t.featureScreenshots && t.featureScreenshots.length">
              <img
                v-for="(shot, ix) in t.featureScreenshots"
                :key="'shot'+ix"
                :src="shot.src"
                :alt="shot.alt"
                loading="lazy"
              >
            </div>
          </section>

          <!-- Download Section -->
          <section id="download" class="content-section download-section">
            <h2><span v-html="t.downloadTitle"></span></h2>
            <p>{{ t.downloadIntro }}</p>
            <table class="app-info-table" v-if="t.downloadDetails && t.downloadDetails.length">
              <tbody>
                <tr v-for="(row, dix) in t.downloadDetails" :key="'dl'+dix">
                  <th>{{ row.label }}</th>
                  <td>{{ row.value }}</td>
                </tr>
              </tbody>
            </table>
            <div class="download-box">
              <button class="download-btn-large" @click="downloadClick">
                <img src="@/assets/android.webp" alt="android"> {{ t.downloadBtn }}
              </button>
              <p class="download-info">{{ t.downloadInfo }}</p>
            </div>
          </section>

          <!-- Installation Guide -->
          <section id="installation" class="content-section" style="margin-top: 50px;">
            <h2><span v-html="t.installTitle"></span></h2>
            <p>{{ t.installIntro }}</p>
            <ol class="installation-steps">
              <li v-for="(step, sx) in t.installSteps" :key="'st'+sx"><strong>{{ step.title }}</strong> {{ step.body }}</li>
            </ol>
            <p class="warning-note" v-html="t.installNoteHtml"></p>
          </section>

          <!-- Safety -->
          <section id="safety" class="content-section">
            <h2>{{ t.safetyTitle }}</h2>
            <p>{{ t.safetyIntro }}</p>
            <ul class="feature-list">
              <li v-for="(si, six) in t.safetyItems" :key="'sf'+six"><strong>{{ si.title }}</strong> {{ si.body }}</li>
            </ul>
            <p class="disclaimer">{{ t.safetyDisclaimer }}</p>
          </section>

          <!-- Latest Update -->
          <section id="update" class="content-section">
            <h2>{{ t.updateTitle }}</h2>
            <p>{{ t.updateIntro }}</p>
            <ul class="feature-list">
              <li v-for="(ui, uix) in t.updateItems" :key="'up'+uix"><strong>{{ ui.title }}</strong> {{ ui.body }}</li>
            </ul>
          </section>

          <!-- Transfer -->
          <section id="transfer" class="content-section">
            <h2>{{ t.transferTitle }}</h2>
            <p>{{ t.transferIntro }}</p>
            <ol>
              <li v-for="(step, trx) in t.transferSteps" :key="'tr'+trx">{{ step }}</li>
            </ol>
            <p>{{ t.transferOutro }}</p>
          </section>

          <!-- Account Safety -->
          <section id="account-safety" class="content-section">
            <h2>{{ t.accountSafetyTitle }}</h2>
            <p>{{ t.accountSafetyIntro }}</p>
            <p>{{ t.accountSafetyLead }}</p>
            <ul>
              <li v-for="(item, asx) in t.accountSafetyItems" :key="'as'+asx">{{ item }}</li>
            </ul>
            <p>{{ t.accountSafetyOutro }}</p>
          </section>

          <!-- Why Choose -->
          <section id="why-choose" class="content-section">
            <h2>{{ t.whyChooseTitle }}</h2>
            <p>{{ t.whyChooseIntro }}</p>
            <template v-for="(item, wcx) in t.whyChooseItems">
              <h3 :key="'wch'+wcx">{{ item.title }}</h3>
              <p :key="'wcp'+wcx">{{ item.body }}</p>
            </template>
            <p>{{ t.whyChooseOutro }}</p>
          </section>

          <!-- Backup -->
          <section id="backup" class="content-section">
            <h2>{{ t.backupTitle }}</h2>
            <p>{{ t.backupIntro }}</p>
            <ol>
              <li v-for="(step, bsx) in t.backupSteps" :key="'bs'+bsx">{{ step }}</li>
            </ol>
            <p>{{ t.backupOutro }}</p>
          </section>

          <!-- Web or PC -->
          <section id="web-pc" class="content-section">
            <h2>{{ t.webPcTitle }}</h2>
            <p>{{ t.webPcP1 }}</p>
            <p>{{ t.webPcP2 }}</p>
            <p class="safety-tip" v-html="t.webPcTipHtml"></p>
          </section>

          <!-- Troubleshooting -->
          <section id="troubleshooting" class="content-section">
            <h2>{{ t.troubleTitle }}</h2>
            <p>{{ t.troubleIntro }}</p>
            <div v-for="(sec, tx) in t.troubleSections" :key="'trs'+tx" class="trouble-block">
              <h3>{{ sec.h3 }}</h3>
              <p>{{ sec.lead }}</p>
              <ul>
                <li v-for="(tip, tix) in sec.tips" :key="'ttp'+tx+'_'+tix">{{ tip }}</li>
              </ul>
            </div>
          </section>

          <!-- Alternatives -->
          <section id="alternatives" class="content-section">
            <h2>{{ t.altTitle }}</h2>
            <p>{{ t.altIntro }}</p>
            <div class="mod-grid">
              <div class="mod-card" v-for="(card, cx) in t.altCards" :key="'alt'+cx">
                <h3><a :href="card.href">{{ card.name }}</a></h3>
                <p>{{ card.desc }}</p>
              </div>
            </div>
          </section>

          <!-- GBWhatsApp vs Other MODs -->
          <section id="gbwhatsapp-vs-other-mods" class="content-section">
            <h2>{{ t.vsModsTitle }}</h2>
            <p v-html="t.vsModsIntroHtml"></p>
            <h3>{{ t.vsModsFmTitle }}</h3>
            <p v-html="t.vsModsFmP"></p>
            <h3>{{ t.vsModsYoTitle }}</h3>
            <p v-html="t.vsModsYoP"></p>
            <h3>{{ t.vsModsPlusTitle }}</h3>
            <p v-html="t.vsModsPlusP"></p>
            <div class="mod-links">
              <a href="/fmwhatsapp/" class="mod-link">{{ t.linkDlFm }}</a>
              <a href="/yowhatsapp/" class="mod-link">{{ t.linkDlYo }}</a>
              <a href="/whatsapp-plus/" class="mod-link">{{ t.linkDlPlus }}</a>
            </div>
          </section>

          <!-- Privacy Features -->
          <section id="privacy-features" class="content-section">
            <h2>{{ t.privacyTitle }}</h2>
            <p>{{ t.privacyIntro }}</p>
            <ul class="feature-list">
              <li v-for="(pit, pix) in t.privacyItems" :key="'pr'+pix"><strong>{{ pit.title }}</strong> {{ pit.body }}</li>
            </ul>
          </section>

          <!-- Customization -->
          <section id="customization" class="content-section">
            <h2>{{ t.customTitle }}</h2>
            <p>{{ t.customIntro }}</p>
            <h3>{{ t.customThemesH3 }}</h3>
            <p>{{ t.customThemesP }}</p>
            <h3>{{ t.customFontsH3 }}</h3>
            <p>{{ t.customFontsP }}</p>
            <h3>{{ t.customConvH3 }}</h3>
            <p>{{ t.customConvP }}</p>
            <h3>{{ t.customHeaderH3 }}</h3>
            <p>{{ t.customHeaderP }}</p>
            <h3>{{ t.customNotifH3 }}</h3>
            <p>{{ t.customNotifP }}</p>
          </section>

          <!-- FAQ -->
          <section id="faq" class="content-section">
            <h2>{{ t.faqTitle }}</h2>
            <div class="faq-item" v-for="(fq, fqIdx) in t.faqItems" :key="'fq'+fqIdx">
              <h3>{{ fq.q }}</h3>
              <p>{{ fq.a }}</p>
            </div>
          </section>

        </main> 
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';
import { HOME_LOCALES } from '@/i18n/home.js';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      showTableOfContents: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
    };
  },
  computed: {
    locale() {
      const name = this.$route?.name || '';
      const lang = name.split('-')[0];
      return ['en', 'es', 'hi', 'pt', 'id'].includes(lang) ? lang : 'en';
    },
    selectedLanguage() {
      return this.locale;
    },
    t() {
      return HOME_LOCALES[this.locale] || HOME_LOCALES.en;
    },
    downloadURL() {
      if (typeof window === 'undefined') {
        return '/gbwhatsapp-apk-download';
      } else {
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    /** 对比表单元格：yes/no/limited 等映射为当前语言 */
    cmpCell(code) {
      const k = String(code);
      const m = {
        yes: this.t.cmpYes,
        no: this.t.cmpNo,
        limited: this.t.cmpLimited,
        thousands: this.t.cmpThousands,
        builtIn: this.t.cmpBuiltIn,
      };
      return m[k] !== undefined ? m[k] : k;
    },
    downloadClick() {
      this.$router.push({
        name: `${this.locale}-download`
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      this.$router.push({ name: `${this.locale}-download` });
    },
    gotoblog() {
      window.location.href = '/blog/';
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 字体改由 index.temp.html / index.html link 异步加载，避免 @import 阻塞首屏 CSS */

.hero-section {
  text-align: center;
  padding: 100px 40px;
  background: linear-gradient(135deg, #1a4d1b 0%, #2d5a27 30%, #3d6b34 60%, #4a7c43 100%);
  color: white;
  border-radius: 40px;
  margin-bottom: 50px;
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  box-shadow: 0 25px 80px rgba(45, 90, 39, 0.35);
  
  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 50%);
    animation: heroShine 20s linear infinite;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(to top, rgba(0,0,0,0.15), transparent);
    pointer-events: none;
  }

  @keyframes heroShine {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .hero-floating-shapes {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    overflow: hidden;

    .shape {
      position: absolute;
      border-radius: 50%;
      opacity: 0.15;
      animation: floatShape 8s ease-in-out infinite;

      &.shape-1 {
        width: 300px;
        height: 300px;
        background: white;
        top: -100px;
        right: -50px;
        animation-delay: 0s;
      }

      &.shape-2 {
        width: 200px;
        height: 200px;
        background: white;
        bottom: -50px;
        left: -50px;
        animation-delay: 2s;
      }

      &.shape-3 {
        width: 150px;
        height: 150px;
        background: rgba(255,255,255,0.3);
        top: 40%;
        left: 10%;
        animation-delay: 4s;
      }
    }

    @keyframes floatShape {
      0%, 100% { transform: translateY(0) scale(1); }
      50% { transform: translateY(-30px) scale(1.05); }
    }
  }

  .hero-content {
    position: relative;
    z-index: 2;
    animation: fadeInUp 0.8s ease-out;
    max-width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h1 {
    font-family: 'Outfit', sans-serif;
    font-size: 3.5em;
    font-weight: 800;
    margin-bottom: 24px;
    color: white;
    position: relative;
    letter-spacing: -1.5px;
    line-height: 1.1;
    text-shadow: 0 4px 20px rgba(0,0,0,0.2);

    .highlight {
      display: inline-block;
      background: linear-gradient(120deg, #a8e6a3 0%, #c8f7c5 50%, #a8e6a3 100%);
      background-size: 200% auto;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: shimmer 3s linear infinite;
    }

    @keyframes shimmer {
      to { background-position: 200% center; }
    }
  }

  .hero-description {
    font-family: 'DM Sans', sans-serif;
    font-size: 1.25em;
    max-width: 680px;
    margin: 0 auto 36px;
    line-height: 1.75;
    opacity: 0.95;
    font-weight: 400;
  }

  .hero-buttons {
    margin: 36px 0;
    position: relative;
  }

  .download-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    background: white;
    color: #1a4d1b;
    border: none;
    padding: 24px 48px;
    border-radius: 20px;
    font-family: 'Outfit', sans-serif;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    box-shadow: 0 10px 40px rgba(0,0,0,0.25), 0 0 0 0 rgba(255,255,255,0.3);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(45,90,39,0.1), transparent);
      transition: left 0.6s ease;
    }

    img {
      width: 32px;
      height: 32px;
      filter: none;
    }

    &:hover {
      transform: translateY(-6px) scale(1.03);
      box-shadow: 0 16px 50px rgba(0,0,0,0.3), 0 0 0 4px rgba(255,255,255,0.2);

      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(-2px) scale(1.01);
    }
  }

  .version-info {
    font-family: 'DM Sans', sans-serif;
    font-size: 0.95em;
    opacity: 0.85;
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(255,255,255,0.12);
    padding: 10px 20px;
    border-radius: 50px;
    backdrop-filter: blur(10px);
    
    &::before {
      content: '';
      width: 8px;
      height: 8px;
      background: #4ade80;
      border-radius: 50%;
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.6; transform: scale(1.2); }
    }
  }
}

.toc-section {
  background: #ffffff;
  padding: 30px;
  border-radius: 24px;
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 50px;

  border: 1px solid rgba(45, 90, 39, 0.08);

  summary {
    font-family: 'Outfit', sans-serif;
    color: #2d5a27;
    font-size: 1.1em;
    font-weight: 600;
    cursor: pointer;
    list-style-position: inside;
  }

  &[open] summary {
    margin-bottom: 20px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 10px 0;
      border-bottom: 1px solid rgba(45, 90, 39, 0.08);

      &:last-child {
        border-bottom: none;
      }

      a {
        font-family: 'DM Sans', sans-serif;
        color: #5a5a5a;
        text-decoration: none;
        transition: all 0.25s ease;
        display: block;
        padding: 4px 0;

        &:hover {
          color: #2d5a27;
          padding-left: 8px;
        }
      }
    }
  }
}

.content-section {
  margin-bottom: 50px;
  padding: 30px;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 2px 10px rgba(45, 90, 39, 0.06);
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 0 auto 50px;
  border: 1px solid rgba(45, 90, 39, 0.08);

  h2 {
    font-family: 'Outfit', sans-serif;
    color: #2d5a27;
    font-size: 1.8em;
    font-weight: 600;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgba(45, 90, 39, 0.1);
  }

  h3 {
    font-family: 'Outfit', sans-serif;
    color: #4a7c43;
    font-size: 1.3em;
    font-weight: 600;
    margin: 25px 0 15px;
  }

  p {
    font-family: 'DM Sans', sans-serif;
    line-height: 1.8;
    color: #5a5a5a;
    margin-bottom: 15px;
    text-align: left;
  }

  ul, ol {
    margin: 15px 0;
    padding-left: 1.25em;
    text-align: left;

    li {
      font-family: 'DM Sans', sans-serif;
      line-height: 1.8;
      margin-bottom: 10px;
      color: #5a5a5a;
      padding-left: 0.35em;
    }
  }

  ol {
    padding-left: 2em;
    li {
      padding-left: 0.25em;
    }
  }
}

.feature-screenshots {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  margin-top: 24px;

  img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    border: 1px solid rgba(45, 90, 39, 0.08);
    background: #f7f5f0;
  }
}

.feature-list {
  list-style: none;
  padding: 0;
  text-align: left;

  li {
    padding: 15px 0 15px 22px;
    position: relative;
    border-bottom: 1px solid rgba(45, 90, 39, 0.08);

    &:last-child {
      border-bottom: none;
    }

    &::before {
      position: absolute;
      left: 0;
      color: #2d5a27;
      font-weight: bold;
      font-size: 1.2em;
    }

    strong {
      color: #4a7c43;
    }
  }
}

.download-section {
  background: linear-gradient(135deg, rgba(45, 90, 39, 0.05) 0%, #fff 100%);
  text-align: center;
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 24px;
  padding: 40px 30px;

  .download-box {
    margin-top: 30px;
  }

  .app-info-table {
    max-width: 620px;
    margin: 24px auto 0;
  }

  .download-btn-large {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    background: linear-gradient(135deg, #2d5a27 0%, #4a7c43 100%);
    color: white;
    border: none;
    padding: 20px 40px;
    border-radius: 50px;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(45, 90, 39, 0.3);

    img {
      width: 28px;
      height: 28px;
      filter: brightness(0) invert(1);
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(37, 211, 102, 0.5);
    }
  }

  .download-info {
    margin-top: 15px;
    color: #666;
    font-size: 0.9em;
  }
}

.app-info-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th,
  td {
    padding: 14px 16px;
    border: 1px solid rgba(45, 90, 39, 0.1);
    font-family: 'DM Sans', sans-serif;
    color: #4f4f4f;
  }

  th {
    width: 38%;
    background: rgba(45, 90, 39, 0.08);
    color: #2d5a27;
    font-weight: 700;
  }
}

.installation-steps {
  background: rgba(45, 90, 39, 0.05);
  padding: 25px 40px;
  border-radius: 16px;
  border-left: 4px solid #2d5a27;
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 0 auto;

  li {
    margin-bottom: 15px;

    strong {
      color: #4a7c43;
    }
  }
}

.warning-note {
  background: rgba(196, 120, 74, 0.1);
  padding: 15px 20px;
  border-radius: 12px;
  border-left: 4px solid #c4784a;
  color: #8b5a2b;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;

  th, td {
    padding: 15px;
    text-align: left;
    border: 1px solid rgba(45, 90, 39, 0.1);
  }

  th {
    background: rgba(45, 90, 39, 0.08);
    color: #2d5a27;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background: rgba(45, 90, 39, 0.03);
  }
}

.mod-links {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 20px;

  .mod-link {
    display: inline-block;
    padding: 12px 24px;
    background: linear-gradient(135deg, #2d5a27 0%, #4a7c43 100%);
    color: white;
    text-decoration: none;
    border-radius: 9999px;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      background: linear-gradient(135deg, #1e3d1a 0%, #2d5a27 100%);
      transform: translateY(-2px);
    }
  }
}

.mod-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;

  .mod-card {
    background: #ffffff;
    padding: 20px;
    border-radius: 16px;
    border: 1px solid rgba(45, 90, 39, 0.08);
    transition: all 0.3s;

    &:hover {
      border-color: rgba(45, 90, 39, 0.2);
      box-shadow: 0 4px 16px rgba(45, 90, 39, 0.1);
    }

    h3 {
      margin: 0 0 10px;

      a {
        color: #2d5a27;
        text-decoration: underline;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    p {
      margin: 0;
      font-size: 0.95em;
    }
  }
}

.faq-item {
  background: rgba(45, 90, 39, 0.05);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  border-left: 4px solid #2d5a27;

  h3 {
    color: #2d5a27;
    font-size: 1.1em;
    margin-bottom: 10px;
  }

  p {
    margin: 0;
  }
}

.safety-tip {
  background: rgba(45, 90, 39, 0.08);
  padding: 15px 20px;
  border-radius: 12px;
  border-left: 4px solid #2d5a27;
  color: #1e3d1a;
}

.disclaimer {
  background: rgba(45, 90, 39, 0.03);
  padding: 15px;
  border-radius: 12px;
  font-size: 0.9em;
  color: #5a5a5a;
  font-style: italic;
  border: 1px solid rgba(45, 90, 39, 0.05);
}

.final-cta {
  text-align: center;
  margin-top: 30px;
}

@media (max-width: 768px) {
  .hero-section {
    padding: 60px 20px;
    border-radius: 20px;

    h1 {
      font-size: 2em;
      letter-spacing: -0.5px;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    .hero-description {
      font-size: 1em;
      margin-bottom: 28px;
    }

    .download-btn {
      width: 100%;
      max-width: 320px;
      padding: 18px 24px;
      font-size: 16px;
      min-height: 56px;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .version-info {
      font-size: 0.82em;
      padding: 8px 16px;
    }

    .hero-floating-shapes {
      .shape {
        &.shape-1 {
          width: 180px;
          height: 180px;
          top: -60px;
          right: -40px;
        }
        &.shape-2 {
          width: 120px;
          height: 120px;
          bottom: -30px;
          left: -30px;
        }
        &.shape-3 {
          display: none;
        }
      }
    }
  }

  .toc-section {
    padding: 20px 15px;
    border-radius: 16px;
    margin-bottom: 30px;

    summary {
      font-size: 1em;
    }

    ul li a {
      font-size: 14px;
      padding: 8px 0;
    }
  }

  .feature-screenshots {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .app-info-table {
    th,
    td {
      padding: 10px 8px;
      font-size: 13px;
    }
  }

  .content-section {
    padding: 20px 15px;
    margin-bottom: 30px;
    border-radius: 16px;

    h2 {
      font-size: 1.35em;
      margin-bottom: 14px;
    }

    h3 {
      font-size: 1.1em;
      margin: 20px 0 10px;
    }

    p {
      font-size: 15px;
      margin-bottom: 12px;
    }

    ul, ol {
      padding-left: 1em;
      margin: 12px 0;

      li {
        font-size: 14px;
        margin-bottom: 8px;
      }
    }
  }

  .download-section {
    padding: 24px 15px;
    border-radius: 16px;

    h2 {
      font-size: 1.35em;
    }

    p {
      font-size: 14px;
    }

    .download-btn-large {
      width: 100%;
      max-width: 320px;
      padding: 18px 24px;
      font-size: 16px;
      min-height: 56px;
      display: flex;
      justify-content: center;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .download-info {
      font-size: 13px;
    }
  }

  .installation-steps {
    padding: 20px 18px;
    border-radius: 12px;
    margin: 0 auto;

    li {
      font-size: 14px;
      margin-bottom: 12px;
    }
  }

  .warning-note {
    padding: 12px 14px;
    font-size: 13px;
  }

  .comparison-table {
    font-size: 0.82em;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-collapse: collapse;

    th, td {
      padding: 10px 8px;
      min-width: 80px;
      word-break: break-word;
    }
  }

  .mod-links {
    flex-direction: column;
    gap: 10px;

    .mod-link {
      width: 100%;
      text-align: center;
      padding: 14px 20px;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 9999px;
    }
  }

  .mod-grid {
    grid-template-columns: 1fr;
    gap: 14px;

    .mod-card {
      padding: 16px;

      h3 {
        font-size: 1em;
      }

      p {
        font-size: 13px;
      }
    }
  }

  .faq-item {
    padding: 16px 14px;
    margin-bottom: 14px;
    border-radius: 10px;

    h3 {
      font-size: 1em;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
    }
  }

  .safety-tip {
    padding: 12px 14px;
    font-size: 13px;
  }

  .disclaimer {
    padding: 12px 14px;
    font-size: 13px;
  }
}
</style>
